<script setup>
import { Menu } from 'ant-design-vue';
defineEmits(['onSelect']);

const { id, items, mode, selectedKeys, inlineCollapsed } = defineProps({
  id: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
  mode: {
    type: String,
    default: 'inline',
  },
  selectedKeys: {
    type: Array,
    default: () => [],
  },
  inlineCollapsed: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div>
    <Menu
      :id="id"
      :items="items"
      :mode="mode"
      @select="(obj) => $emit('onSelect', obj)"
      :selectedKeys="selectedKeys"
      :inlineCollapsed="inlineCollapsed"
    />
  </div>
</template>

<style lang="scss" scoped></style>
